import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { priceInsight, priceInsightLabel, formatApproxMarketEur, type ListingTrustInput } from '@redevicer/shared'

interface Props {
  listing: Pick<ListingTrustInput, 'price' | 'ai_recommended_eur'>
  /** Live catalog pricing — overrides stale persisted ai_recommended_eur. */
  marketEurOverride?: number | null
  variant?: 'compact' | 'detail'
  showMarket?: boolean
  className?: string
}

export default function PriceInsightBadge({
  listing,
  marketEurOverride,
  variant = 'compact',
  showMarket = false,
  className = '',
}: Props) {
  const { t } = useTranslation()
  const insight = useMemo(
    () =>
      priceInsight({
        price: listing.price,
        ai_recommended_eur: marketEurOverride ?? listing.ai_recommended_eur,
      }),
    [listing.price, listing.ai_recommended_eur, marketEurOverride],
  )
  const label = useMemo(
    () => priceInsightLabel(insight.level, insight, variant === 'compact'),
    [insight, variant],
  )

  if (!label) return null

  return (
    <div
      className={`price-insight-badge price-insight-badge--${insight.level}${className ? ` ${className}` : ''}`}
    >
      <span className="price-insight-badge__label">{t(label.key, label.vars ?? {})}</span>
      {showMarket && insight.marketEur != null ? (
        <span className="price-insight-badge__market">
          {t('trust.report.marketPrice')}: {formatApproxMarketEur(insight.marketEur)}
        </span>
      ) : null}
    </div>
  )
}
